module.exports = __webpack_public_path__ + "img/lang-uz.66174d2f.svg";